module.exports = __webpack_public_path__ + "static/media/ic-close-white.c43556fd.svg";